// extracted by mini-css-extract-plugin
export default {"indicator":"completenessIndicator_indicator__aYbQC","unfinishedIcon":"completenessIndicator_unfinishedIcon__kdEda","icon":"completenessIndicator_icon__D-Ld4"};